// extracted by mini-css-extract-plugin
module.exports = {"button":"switchbutton_button__3oSnK"};